import momenJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import Loader from "react-loader-spinner";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, FileEarmarkPost, JournalText, List, PrinterFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { bomTypes, exportToExcel, invoiceTypes, invoiceTypesArray, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/Invoice";
import BihamtaTable from "../../Components/BihamtaTable";
import { GetInventoryTurnoverReport } from "../store/api/ReportsAPI";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom, faWarehouse } from "@fortawesome/free-solid-svg-icons";

const InventoryTurnoverReport = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [selectedStorage, selectStorage] = useState(null);
    const [popProducts, setPopProducts] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const [popStorage, setPopStorage] = useState({ show: false });
    const settingNames = ["ProductGrouppingType"];
    const { filterData, systemSettings } = useSelector(state => { return { filterData: state.ReportReducer.turnoverReportFilters, systemSettings: state.InvoiceReducer.systemSettings } })

    const [dateFilters, setDateFilters] = useState({
        ContactDateFrom: filterData?.ContactDateFrom,
        ContactDateTo: filterData?.ContactDateTo
    })
    const productGrouppingType = systemSettings && Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const { handleSubmit, register, errors } = useForm();
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        const contactDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        const contactDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (contactDateFrom !== '') {
            data.ContactDateFrom = dateFilters.ContactDateFrom;
        }
        if (contactDateTo !== '') {
            data.ContactDateTo = dateFilters.ContactDateTo;
        }
        if (data.ShowZNCounts && Array.isArray(data.ShowZNCounts)) {
            data.ShowZNCounts = data.ShowZNCounts.some(s => s === "on");
        }
        data.Skip = 0;
        dispatch(GetInventoryTurnoverReport(data))
    }
    function showModalStorage(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        e.preventDefault();
        if (filterData?.StorageName) {
            filterData.StorageName = null;
        }
        setPopStorage({
            show: true,
            setStorageData: selectStorage,
            value: e.key
        })
    }
    function showModalProducts(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        e.preventDefault();
        if (filterData?.ProductName) {
            filterData.ProductName = null;
        }
        const onSelectProduct = (p) => {
            const pName = p ? (productGrouppingType !== 1 ? p.HolderName + "-" : "") + p.ProductName + "-" + p.ProductModel : "";
            if (p) {
                p.ProductName = pName;
            }
            selectProduct(p);
        }
        setPopProducts({
            show: true,
            value: e.key,
            forStorageReport: true,
            setProductData: onSelectProduct
        })
    }
    function toExcel() {
        const url = "api/StorageAPI/GetInventoryTurnoverReport";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("InventoryTurnoverReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        history.push({
            pathname: `/PrintViewer/InventoryTurnoverReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/StorageAPI/GetInventoryTurnoverReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function clearFilters() {
        frmFilters.current.reset();
        selectStorage(null);
        selectProduct(null);
        setDateFilters({
            ContactDateFrom: null,
            ContactDateTo: null
        })
        dispatch(GetInventoryTurnoverReport({ Skip: 0, Take: 10 }));
    }
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "StorageName", colTitle: "انبار", showInMobile: true, styleCondition: (row) => Number(row.InvoiceNumber) === -1 ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colName: "PInvoiceType", colTitle: "نوع فاکتور", showInMobile: true, styleCondition: (row) => Number(row.InvoiceNumber) === -1 ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colName: "InvoiceNumber", colTitle: "شماره فاکتور", showInMobile: true, styleCondition: (row) => Number(row.InvoiceNumber) === -1 ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colName: "PContactDate", colTitle: "تاریخ فاکتور" },
        { colName: "Description", colTitle: "شرح فاکتور" },
        { colName: "CustomerName", colTitle: "طرف حساب" },
        { colName: "InputCount", colTitle: "تعداد وارده" },
        { colName: "OutputCount", colTitle: "تعداد صادره" },
        { colName: "RowInventory", colTitle: "موجودی", styleCondition: (row) => Number(row.InvoiceNumber) === -1 ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colName: "KalaMeanAvgPrice", colTitle: "میانگین موزون", colType: "currency" },
        { colName: "KalaLastPurchasePrice", colTitle: "قیمت آخرین خرید", colType: "currency" },
        { colName: "KalaLastSalePrice", colTitle: "قیمت آخرین فروش", colType: "currency" }
    ]
    const tableRowBtns = [
        {
            type: "common", tooltip: "نمایش فاکتور", title: "نمایش فاکتور", className: "group-Btn-smalll", icon: <FileEarmarkPost color="#1e76c4" size={21} className="rowBtn" />, onclick: showInvoice
        }
    ]
    function showInvoice(row) {
        if (row.InvoiceType !== invoiceTypes.Disassembly && row.InvoiceType !== invoiceTypes.ProductionInvoice) {
            history.push(`/Sale/Invoice/${row.InvoiceType}/${row.InvoiceID}/${row.IsFormal}`);
        }
        else if (row.InvoiceType === invoiceTypes.Disassembly) {
            window.open(`/Production/Disassembly/${row.InvoiceID}`);
        }
        else if (row.InvoiceType === invoiceTypes.ProductionInvoice) {
            window.open(`/Production/BoM/${row.InvoiceID}/${bomTypes.ProductionInvoice}/${Number(row.InputCount) > 1 ? 1 : 0}`)
        }
    }
    useEffect(() => {
        document.body.classList = 'notMain';
        dispatch(getSystemSettings(settingNames));
        if (filterData?.FromStorageStatus) {
            search(filterData);
        }
    }, [])
    return (
        <div className="container-fluid mt-1">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faWarehouse} size="lg" />&nbsp;
                    گزارش کاردکس کالا
                </Card.Header>
                <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                <ModalProducts popData={popProducts} setProductPopup={setPopProducts} productGrouppingType={productGrouppingType} />
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <input type="hidden" ref={register({ required: true })} name="ProductID" readOnly value={selectedProduct?.ProductID ?? filterData?.ProductID ?? ""} />
                                <Form.Control name="ProductName" placeholder="مشخصات کالا" ref={register({})} readOnly value={selectedProduct?.ProductName ?? filterData?.ProductName ?? ""} onKeyDown={showModalProducts} />
                                <Button className="btn-input-tiny" style={{ top: "8px" }} onClick={showModalProducts}><List size={21} /></Button>
                                {
                                    errors?.ProductID && <small className="errors">کالا انتخاب نشده است</small>
                                }
                            </Col>
                            <Col md={2} className="form-group">
                                <input type="hidden" ref={register({})} name="StorageID" value={selectedStorage?.StorageID ?? filterData?.StorageID ?? ""} />
                                <Form.Control name="StorageName" ref={register({})} readOnly value={selectedStorage?.StorageName ?? filterData?.StorageName ?? ""} placeholder="نام انبار"
                                    onKeyDown={showModalStorage} />
                                <Button className="btn-input-tiny" style={{ top: "8px" }} onClick={showModalStorage}><List size={21} /></Button>
                            </Col>
                            <div className="col-md-2 form-group">

                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateFrom" placeholder="تاریخ فاکتور از"
                                    value={dateFilters.ContactDateFrom ? momenJalaali(dateFilters.ContactDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ContactDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateTo" placeholder="تاریخ فاکتور تا"
                                    value={dateFilters.ContactDateTo ? momenJalaali(dateFilters.ContactDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ContactDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <Col md={2} className="form-group">
                                <select className="form-control" name="Take" ref={register({})} defaultValue={filterData?.Take ?? -1}>
                                    <option value={10}>نمایش 10 ردیف در صفحه</option>
                                    <option value={20}>نمایش 20 ردیف در صفحه</option>
                                    <option value={30}>نمایش 30 ردیف در صفحه</option>
                                    <option value={50}>نمایش 50 ردیف در صفحه</option>
                                    <option value={100}>نمایش 100 ردیف در صفحه</option>
                                    <option value={-1}>نمایش تمام ردیفها در صفحه</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <select className="form-control" defaultValue={filterData?.InvoiceType ?? ""} name="InvoiceType" ref={register({})}>
                                    <option value="">نوع فاکتور را انتخاب کنید</option>
                                    {invoiceTypesArray.map((type, i) => <option key={i} value={type.TypeName}>{type.TypeStr}</option>)}
                                </select>
                            </Col>
                        </Row>
                        <Button type="submit" variant="secondary" className="group-Btn-large mt-1"><JournalText size={18} />&nbsp;نمایش گزارش</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable
                        columns={tableCols}
                        rowButtons={tableRowBtns}
                        filterData={filterData}
                        searchMethod={(data) => dispatch(GetInventoryTurnoverReport(data))}
                        reducerName="ReportReducer" 
                        objectName="invTurnoverReport"
                        className="mt-0 mb-0" 
                        maxHeight={500} 
                        searchable ={true}/>
                </Card.Body>
            </Card>
        </div>
    )

}
export default InventoryTurnoverReport
